import './index.scss';
import React, { useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip'
import Utils from '../../Helper/utils';
import he from 'he';

function ModalEditLessonTitle({ lessonTitle, lessonDescription, updateLessonTitle, setOpenModalSaveTitleLesson, openModalSaveTitleLesson }) {
    const [lessonTitleState, setLessonTitleState] = useState(lessonTitle);
    const [lessonDescriptionState, setLessonDescriptionState] = useState(lessonDescription);
    const [saveDisabled, setSaveDisabled] = useState('');

    useEffect(() => {
        if (openModalSaveTitleLesson) {
            setLessonTitleState(lessonTitle)
            checkTitle(lessonTitle)
            setLessonDescriptionState(lessonDescription)
        }
    }, [openModalSaveTitleLesson]);

    const handleSaveLessonTitle = () => {
        // manager.settings.lessonTitle = lessonTitle;
        let inputTitleElm = document.getElementById('input-edit-lesson-title');
        let inputTitleElmValue = inputTitleElm.value;
        if (inputTitleElmValue.length < 5 || inputTitleElmValue.length > 80) {
            Utils.showError('Lesson Name minimum 5 and maximum 80');
            return false;
        }

        let inputDescriptionElm = document.getElementById('input-edit-lesson-description').value;
        let inputDescriptionElmValue = inputDescriptionElm;
        if ((inputDescriptionElmValue.length > 0 && inputDescriptionElmValue.length < 5) || inputDescriptionElmValue.length > 250) {
            Utils.showError('Lesson Description minimum 5 and maximum 250');
            return false;
        }
        updateLessonTitle({ lessonTitle: inputTitleElmValue, lessonDescription: inputDescriptionElm });
        window.jQuery('#tbcourse-modal-edit-lesson-title').modal('hide');
    }

    const handleOnChange = (e) => {
        let currentValue = e.currentTarget.value;
        setLessonTitleState(currentValue)
        checkTitle(currentValue)
        setOpenModalSaveTitleLesson(false)
    }

    const checkTitle = (currentValue) => {
        if (currentValue.length < 5 || currentValue.length > 80) {
            setSaveDisabled(true)
            document.getElementById('input-edit-lesson-title').className = 'form-control is-invalid text-danger';
        } else {
            setSaveDisabled(false)
            document.getElementById('input-edit-lesson-title').className = 'form-control';
        }
    }

    const handleOnChangeDescription = (e) => {
        let currentValue = e.currentTarget.value;
        setLessonDescriptionState(currentValue)
        setOpenModalSaveTitleLesson(false)
    }

    return (
        <div className="tbcourse-modal tbcourse-modal-edit-lesson-title modal" id="tbcourse-modal-edit-lesson-title" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0 pb-0">
                        {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <IconCross/>
                            </span>
                        </button> */}
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <h5>Lesson Name</h5>
                        <p>Create lesson name that can represent the activity education for the specific<br />lesson you try to make.</p>
                        <div className="form-group mt-3">
                            <label htmlFor="input-edit-lesson-title" className="text-uppercase">
                                Lesson Name
                                <Tooltip id="my-tooltip" />
                                <button className="btn btn-link ms-1 p-0 pb-1" data-tooltip-id="my-tooltip" data-tooltip-content="Recommended less than 80 characters text" data-tooltip-place="top">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                        <path d="M6.6 4.2H5.4V3H6.6M6.6 9H5.4V5.4H6.6M6 0C5.21207 0 4.43185 0.155195 3.7039 0.456723C2.97595 0.758251 2.31451 1.20021 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.31451 10.7998 2.97595 11.2417 3.7039 11.5433C4.43185 11.8448 5.21207 12 6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 5.21207 11.8448 4.43185 11.5433 3.7039C11.2417 2.97595 10.7998 2.31451 10.2426 1.75736C9.68549 1.20021 9.02406 0.758251 8.2961 0.456723C7.56815 0.155195 6.78793 0 6 0Z" fill="#949494" />
                                    </svg>
                                </button>
                            </label>
                            <input
                                type="text"
                                id="input-edit-lesson-title"
                                className="form-control"
                                placeholder="Lesson title"
                                value={he.decode(lessonTitleState)}
                                onChange={handleOnChange}
                            />
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="input-edit-lesson-description" className="text-uppercase">
                                Description (optional)
                            </label>
                            <textarea
                                type="text"
                                id="input-edit-lesson-description"
                                className="form-control"
                                rows="4"
                                maxLength="250"
                                placeholder="Fill your lesson description here"
                                value={he.decode(lessonDescriptionState)}
                                onChange={handleOnChangeDescription}
                            />
                        </div>
                        <button type="button" className="btn btn-primary mt-3 float-end px-5" onClick={handleSaveLessonTitle} disabled={saveDisabled}>Save</button>
                        {/* <div className="input-group-append">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSaveLessonTitle}
                                >Set Name</button>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalEditLessonTitle;
